import React, { useRef, useState } from 'react';

interface OtpInputProb {
    length: number;
    onChange: (opt: string, ctrlIndex: number) => void;
}

const OtpInput = (prob: OtpInputProb) => {
    const length = prob.length;
    const onChange = prob.onChange;
    const inputsRef = useRef<(HTMLInputElement | null)[]>([]); // To keep references of all inputs
    const [otp, setOtp] = useState<string[]>(new Array(length).fill(""));

    const handleChange = (element: HTMLInputElement, index: number) => {
        const value = element.value;

        // Only update if the entered value is a number
        if (/^[0-9]$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            onChange(newOtp.join(""), index);

            // Move to the next input
            if (inputsRef.current[index + 1]) {
                inputsRef.current[index + 1]?.focus();
                inputsRef.current[index + 1]?.select(); // Select all text after focusing
            }
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        const { key } = event;

        // Handle Backspace key: Delete current value or move to the previous input
        if (key === "Backspace") {
            if (otp[index]) {
                const newOtp = [...otp];
                newOtp[index] = ""; // Clear current value
                setOtp(newOtp);
                onChange(newOtp.join(""), index);
            } else if (inputsRef.current[index - 1]) {
                inputsRef.current[index - 1]?.focus(); // Move to previous input
                const newOtp = [...otp];
                newOtp[index - 1] = ""; // Clear the previous value
                setOtp(newOtp);
                onChange(newOtp.join(""), index);
            }
        }

        // Handle ArrowLeft key: Move focus to the previous input
        if (key === "ArrowLeft" && inputsRef.current[index - 1]) {
            inputsRef.current[index - 1]?.focus();
            setTimeout(() => inputsRef.current[index - 1]?.select(), 0); // Select the text after focusing
        }

        // Handle ArrowRight key: Move focus to the next input
        if (key === "ArrowRight" && inputsRef.current[index + 1]) {
            inputsRef.current[index + 1]?.focus();
            setTimeout(() => inputsRef.current[index + 1]?.select(), 0); // Select the text after focusing
        }

        // Handle number key to overwrite the current value and move to the next input
        if (/^[0-9]$/.test(key)) {
            event.preventDefault(); // Prevent the default behavior of appending the number to the current value
            const newOtp = [...otp];
            newOtp[index] = key; // Replace the value directly
            setOtp(newOtp);
            onChange(newOtp.join(""), index);

            // Move to the next input
            if (inputsRef.current[index + 1]) {
                inputsRef.current[index + 1]?.focus();
                setTimeout(() => inputsRef.current[index + 1]?.select(), 0); // Select the text after focusing
            }
        }
    };


    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        // Select the text when input gets focus
        event.target.select();
    };
    return (
        <div style={{ display: 'flex', gap: '10px' }}>
            {
                otp.map((_, index) => (
                    <input
                        key={index}
                        id={"txt_otp_" + index}
                        type="tel" className='form-control otp-input'
                        maxLength={1}
                        value={otp[index]}
                        // onChange={(e) => handleChange(e.target, index)}
                        ref={(el) => (inputsRef.current[index] = el)} // Store input refs
                        onChange={(e) => handleChange(e.target, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onFocus={handleFocus}
                    />
                ))
            }
        </div >
    );
};

// const App = () => {
//   const handleOtpChange = (otp: string) => {
//     console.log('OTP entered:', otp);
//   };

//   return (
//     <div>
//       <h2>Enter OTP</h2>
//       <OtpInput length={6} onChange={handleOtpChange} />
//     </div>
//   );
// };

export default OtpInput;
